export const productPath = ({urlSlug,productId}) => `/tienda/${encodeURIComponent(urlSlug || productId)}`;
